"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Arrow_1 = require("components/styled/Arrow");
const Colors_1 = require("components/styled/Colors");
const Containers_1 = require("components/styled/Containers");
const Grid_1 = require("components/styled/Grid");
const Map_1 = require("components/styled/img/Map");
const MapMobile_1 = require("components/styled/img/MapMobile");
const Text_1 = require("components/styled/Text");
exports.Network = ({ title, content }) => (React.createElement(Containers_1.NetworkContainer, null,
    React.createElement(Containers_1.SectionContent, null,
        React.createElement(Grid_1.Row, null,
            React.createElement(Grid_1.Column, { width: 6, widthTablet: 4 },
                React.createElement(Text_1.SectionTitle, null, title),
                React.createElement(Text_1.SectionText, null, content),
                React.createElement(MapMobile_1.MapMobile, null)),
            React.createElement(Grid_1.Column, { width: 6, widthTablet: 4 },
                React.createElement(Map_1.Map, null))),
        React.createElement(Arrow_1.ArrowLink, { color: Colors_1.SPACE, target: "2", light: true }))));



// WEBPACK FOOTER //
// ./src/components/sections/Network.tsx